<style lang="less">
.app-footer {
  text-align: center;
  padding: 10px 0 30px;
  color: rgba(0, 0, 0, 0.45);
  a {
    color: rgba(0, 0, 0, 0.45);
  }
}
.app-footer .btn-chat {
  position: fixed;
  z-index: 99999;
  bottom: 10px;
  right: 26px;
  font-size: 20px;
  padding: 9px 13px;
  border-radius: 50%;
  color: #e4e4e4;
  cursor: pointer;
  background: #4f657d;
  transition: 0.5s;
}
.app-footer .btn-chat:hover {
  background: #565d65;
}
</style>

<template>
  <div class="app-footer">© {{ getCurrentYear }} F360°.</div>
</template>
<script>
export default {
  data() {
    return {
      f360chat: process.env.NODE_ENV == 'production',
      isLogado: false
    };
  },
  mounted() {
    const vm = this;
    if (process.env.NODE_ENV == 'development' || this.is_mobile) {
      console.log('cancelar a abertura do chat');
      return;
    }

    setTimeout(function () {
      var user = Utils.getLocal2Json('v360.user');
      if (typeof vm !== 'undefined' && vm.validarZendesk()) {
        vm.$zendesk.zE('webWidget', 'prefill', {
          name: {
            value: user.nome,
            readOnly: true // optional
          },
          email: {
            value: user.email,
            readOnly: true // optional
          }
        });
        vm.$zendesk.show();
      }
    }, 100);
  },
  methods: {
    validarZendesk() {
      return typeof this.$zendesk !== 'undefined' && this.$zendesk !== undefined && typeof this.$zendesk.zE === 'function';
    }
  },
  computed: {
    getCurrentYear() {
      return moment().format('YYYY');
    }
  }
};
</script>
